<template>
  <div role="status" aria-live="polite" class="flex items-center justify-center">
    <span class="sr-only">Loading dashboard content</span>
    <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-blue-600" />
  </div>
</template>
